import {Component, ElementRef, EventEmitter, TemplateRef, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {ActivatedRoute, Router} from "@angular/router";
import {NumeralService} from "../services/Numeral.service";
import {TaxPlanningService} from "../tpiq-services/tax-planning.service";
import {LoadingService} from "../services/LoadingService";
import {ToastService} from "../services/Toast.service";
import {StateService} from "../services/StateService";
import {SwitchBoard} from "../services/SwitchBoard";
import {Session} from "../services/Session";
import {TOAST_TYPE} from "../constants/Tpiq.constants";
import {State} from "../models/State";
import {PageTitleService} from "../services/PageTitle";
import {NewTpiqService} from "../tpiq-services/new-tpiq.service";
import {ManageTaxStrategiesServices} from "../tpiq-services/manage-tax-strategies.service";
import {environment} from "../../environments/environment";
import {v4 as uuid} from 'uuid';
import {catchError, takeUntil} from "rxjs/operators";
import {forkJoin, of} from "rxjs";
import {TAX_PLANNING_TYPES} from "../constants/tax-planning.constants";
import {FormsModule} from "@angular/forms";
import {TpiqSelectDropdownComponent} from "../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {FormatAmountPipe} from "../pipes/format-amount.pipe";
import {TpiqFileUploadComponent} from "../tpiq-file-upload/tpiq-file-upload.component";
import {DashboardTasksComponent} from "./dashboard-tasks/dashboard-tasks.component";
import {DashboardTodosComponent} from "./dashboard-todos/dashboard-todos.component";
import {HighchartsChartModule} from "highcharts-angular";
import { MatIcon } from '@angular/material/icon';
import * as Highcharts from 'highcharts';
import {ClientSelectCreateComponent} from "./client-select-create/client-select-create.component";

declare let _: any;
declare let jQuery: any;
declare let $: any;
const MAX_FILE_SIZE = 275 * 1024 * 1024;
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, FormatAmountPipe, FileUploadModule, TpiqFileUploadComponent,
  DashboardTasksComponent, DashboardTodosComponent, HighchartsChartModule, MatIcon, ClientSelectCreateComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  routeSub: any;
  user: any;
  org: string;
  hasFirmsMostPopularPlansData = false;
  hasTop5strategiesData = false;
  chartColors: Array<any> = ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'];
  firmsMostPopularPlans: any;
  top5strategies: any;
  firmTaxPlansGraphName = '';
  yearFilterForFirmGraph: any;
  yearFilterForTop5Strategies: any;
  currentYear: any;
  hasTotalSavingsByStrategyData = false;
  groupedTotalTaxSavingsByStrategyChartOptions: any;
  yearFilter: any;
  defaultGraphType = 'Strategy';
  graphRelatedTypes: Array<any> = [
    {type: 'Strategy'},
    {type: 'Client'}
  ];
  filterYears: Array<any> = [];
  filterYearsForMonthGraph: Array<any> = [];
  yearFilterAllExist = false;
  yearFilterForFirmAllExist = false;
  yearFilterForTop5StrategiesExist = false;
  taxPlanningsDefaultYear:boolean = false;
  firmStrategiesDefaultYear:boolean = false;
  top5StrategiesDefaultYear:boolean = false;
  currentTaxPlanningsDefaultYear: any;
  currentFirmStrategiesDefaultYear: any;
  currentTop5StrategiesDefaultYear: any;
  showPlansInfo: boolean = false;
  plansFilterStrategyId: any;
  plansFilterYear: any;
  filterType: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  dashboardAccess: boolean;
  dashboardMetrics: any;
  filterYearForSavings: any;
  savingsEditable: boolean = false;
  yearsForSavings: Array<any> = [];
  totalTaxSavings = 0;
  columns: Array<any> = [
    {name: 'name', title: 'Name', type: 'html', classes: 'pointer zero-overflow', sortable: true},
    {name: 'description', title: 'Description', type: 'normal', classes: 'pointer zero-overflow tracker-desc', sortable: true}
  ];
  announcementsList: Array<any> = [];
  reveal: any = {
    addOrEditAnnouncement: false,
    activeAnnouncementsExist: false,
    openCreateClientPopup: false,
    openBulkUploadPopup: false,
  };
  editMode = false;
  announcementId: any;
  activeAnnouncements: Array<any> = [];
  currentActiveAnnouncementToShow: any;
  currentAnnouncementIndex: any;
  gridOrder: Array<any> = [];
  @ViewChild('publishedSavings') publishedSavings: TemplateRef<any>;
  @ViewChild('announcements') announcements: TemplateRef<any>;
  @ViewChild('popularStrategies') popularStrategies: TemplateRef<any>;
  @ViewChild('tasks') tasks: TemplateRef<any>;
  @ViewChild('todos') todos: TemplateRef<any>;
  uploader: FileUploader;
  client: any = {
    defaultYear: '',
    relatedParties: [],
    status: 'Draft',
    filingStatus: 'Single'
  };
  uploadSourceId: any;
  years: Array<any> = [];
  filingStatusList: Array<any> = [
    {name: 'Single'},
    {name: 'MFJ'},
    {name: 'MFS'},
    {name: 'Head of Household'},
    {name: 'Estate'},
    {name: 'Trust'},
  ];
  clientsList: Array<any> = [];
  types: Array<any> = TAX_PLANNING_TYPES;
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  @ViewChild(ClientSelectCreateComponent) clientSelectCreateComponent: ClientSelectCreateComponent;
  clientsCountData: any;
  Highcharts: typeof Highcharts = Highcharts;
  hasDropZoneOver: boolean = false;
  isSingleFileUpload: boolean = true;
  uploadCanceled: boolean = false;
  showUploadContinueBtn = false;
  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private numeralService: NumeralService,
    private taxPlanningService: TaxPlanningService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private stateService: StateService,
    private switchBoard: SwitchBoard,
    private titleService: PageTitleService,
    private newTpiqService: NewTpiqService,
    private manageTaxStrategiesServices: ManageTaxStrategiesServices,
  ) {
    this.titleService.setPageTitle('');
    this.org = Session.getOrg();
    const sessionUser = Session.getUser();
    this.user = sessionUser?.id;
    this.client.defaultYear = new Date().getFullYear();
    this.setFileUploader();
    this.currentYear = new Date().getFullYear();
    this.filterYearForSavings = this.currentYear;
    this.loadingService.triggerLoadingEvent(true);
    forkJoin({
      clients: this.taxPlanningService.getClientsForCoreFocusUpload(this.org, this.user).pipe(catchError(() => of([] as any[]))),
      gridOrder: this.taxPlanningService.dashboardGridOrder(this.org, this.user).pipe(catchError(() => of([] as any[]))),
      metrics: this.newTpiqService.getDashboardMetricData(this.org, this.user).pipe(catchError(() => of(null as any))),
      announcements: this.newTpiqService.getAnnouncementsList(this.org, this.user).pipe(catchError(() => of([] as any[]))),
      savings: this.taxPlanningService.getTaxSavingsForYear(this.org, this.user, this.filterYearForSavings).pipe(catchError(() => of({total: 0} as any))),
    }).subscribe({
      next: (results: any) => {
        this.setClientsList(results.clients || []);
        this.gridOrder = results.gridOrder && results.gridOrder.length > 0
          ? results.gridOrder
          : ['publishedSavings', 'announcements', 'popularStrategies', 'tasks', 'todos'];
        this.dashboardMetrics = results.metrics;
        this.announcementsList = results.announcements || [];
        this.totalTaxSavings = results.savings?.total || 0;
        this.savingsEditable = false;
        this.loadingService.triggerLoadingEvent(false);
      },
      error: () => this.loadingService.triggerLoadingEvent(false)
    });
    if (this.newTpiqService.getShowAnnouncements()) {
      this.getActiveAnnouncementsForUser();
    } else {
      this.newTpiqService.setShowAnnouncements(false);
    }
    this.fillYears();
    this.routeSub = this._route.params.subscribe(params => {
      this.chaeckDashboardAccess();
    });
    this.switchBoard.onPageChangeListener.next({});
    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      if (this.showPlansInfo) {
        this.showPlansInfo = false;
        this.titleService.setPageTitle('');
      }
    });
  }

  ngOnInit(): void {
  this.switchBoard.onLoginByToken.subscribe((isTokenLogin: boolean) => {
    if (!isTokenLogin) {
      this.initSleek();
    }
  });
}
initSleek() {
    window['$sleek']=[];
    window['SLEEK_PRODUCT_ID']=771146479;
    (() => {
      const d = document;
      const s = d.createElement("script");
      s.src = "https://client.sleekplan.com/sdk/e.js";
      s.async = Boolean(1);
      d.getElementsByTagName("head")[0].appendChild(s);
    })();
  }
  ngAfterViewInit(){
    jQuery("#dashboard-grids").sortable({
      update: (event, ui) => {
        const order = [];
        const org = Session.getOrg();
        const userId = Session.getUser().id;
        const env = (environment.production) ? 'https://services.taxplaniq.com' : 'https://dev-services.taxplaniq.com';
        jQuery('.dashboard-grid').each(function(index) {
          order.push(jQuery(this).attr("id"));
        });
        $.ajax({
          type: 'POST',
          url: env + `/TaxPlanningServices/orgs/${org}/users/${userId}/dashboard/order`,
          contentType: 'application/json',
          data: JSON.stringify(order),
          headers: {
            Authorization: 'Bearer ' + Session.getToken()
          }
        });
      }
    });
  }

  getDashboardMetrics() {
    this.loadingService.triggerLoadingEvent(true);
    this.newTpiqService.getDashboardMetricData(this.org, this.user).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.dashboardMetrics = response;
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : `Failed to get dashboard metrics`;
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });

  }

  getClientsCount() {
    this.loadingService.triggerLoadingEvent(true);
    this.newTpiqService.getClientsCountData(this.org, this.user).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.clientsCountData = response;
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : `Failed to get clients count`;
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });

  }

  chaeckDashboardAccess() {
    const accessInfo = Session.getUserAccessInfo();
    if (accessInfo && accessInfo.dashboardAccess) {
      this.dashboardAccess = true;
      this.getDefaultYearForDashboard();
    } else {
      this.dashboardAccess = false;
    }
  }

  fillYears(){
    this.filterYears.push({id: 'All', name: 'All'});
    for (let i = 2020; i <= this.currentYear + 1; i++){
      this.filterYears.push({id: i.toString(), name: i.toString()});
      this.filterYearsForMonthGraph.push({id: i.toString(), name: i.toString()});
      this.yearsForSavings.push({id: i.toString(), name: i.toString()});
    }
    for (let i = this.currentYear - 5; i <= this.currentYear + 5; i++){
      this.years.push({id: i.toString(), name: i.toString()});
    }
  }

  setGraphType($event) {
    this.defaultGraphType = $event.type;
    this.loadingService.triggerLoadingEvent(true);
    this.getTotalTaxSavingsPublishedByStrategy();
  }

  setYear($event, type?) {
    if (type && type === 'tax plans by firm') {
      if (this.yearFilterForFirmGraph != $event.id) {
        this.yearFilterForFirmGraph = $event.id;
        this.yearFilterForFirmAllExist = ($event.id == 'All') ? true : false;
        this.loadingService.triggerLoadingEvent(true);
        this.firmStrategiesDefaultYear = (this.currentFirmStrategiesDefaultYear == $event.id) ? true : false;
        this.getFirmsMostPopularPlans();
      }
    } else if (type && type === 'top 5 strategies') {
      if (this.yearFilterForTop5Strategies != $event.id) {
        this.yearFilterForTop5Strategies = $event.id;
        this.yearFilterForTop5StrategiesExist = ($event.id == 'All') ? true : false;
        this.loadingService.triggerLoadingEvent(true);
        this.top5StrategiesDefaultYear = (this.currentTop5StrategiesDefaultYear == $event.id) ? true : false;
        this.getTop5StrategiesUsed();
      }
    } else if (type && type === 'year tax savings') {
      this.filterYearForSavings = $event.id;
      this.getSavingsForYear();
    } else if (type && type === 'planYear') {
      this.client['defaultYear'] = $event.id;
    } else {
      if (this.yearFilter != $event.id) {
        this.yearFilter = $event.id;
        this.yearFilterAllExist = ($event.id == 'All') ? true : false;
        this.loadingService.triggerLoadingEvent(true);
        this.taxPlanningsDefaultYear = (this.currentTaxPlanningsDefaultYear == $event.id) ? true : false;
        this.getTotalTaxSavingsPublishedByStrategy();
      }
    }
  }

  setTaxPlanningsDefaultYear() {
    this.taxPlanningsDefaultYear = !this.taxPlanningsDefaultYear;
    if (this.taxPlanningsDefaultYear) {
      this.currentTaxPlanningsDefaultYear = this.yearFilter;
      this.makeItDefaultYear(this.currentTaxPlanningsDefaultYear, 'tax-savings');
    }
  }

  setFirmStrategiesDefaultYear() {
    this.firmStrategiesDefaultYear = !this.firmStrategiesDefaultYear;
    if (this.firmStrategiesDefaultYear) {
      this.currentFirmStrategiesDefaultYear = this.yearFilterForFirmGraph;
      this.makeItDefaultYear(this.currentFirmStrategiesDefaultYear, 'published-strategies');
    }
  }

  setTop5StrategiesDefaultYear() {
    this.top5StrategiesDefaultYear = !this.top5StrategiesDefaultYear;
    if (this.top5StrategiesDefaultYear) {
      this.currentTop5StrategiesDefaultYear = this.yearFilterForTop5Strategies;
      this.makeItDefaultYear(this.currentTop5StrategiesDefaultYear, 'published-strategies');
    }
  }

  makeItDefaultYear(year, graphName) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.makeDefaultYear(Session.getOrg(), this.user, year, graphName).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.taxPlanningService.clearDefaultYearsData();
      this.toastService.pop(TOAST_TYPE.success, 'Default year changed successfully');
    });
  }

  getDefaultYearForDashboard() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getDashboardDefaultYearData(Session.getOrg(), this.user).subscribe(response => {
      this.yearFilter = (response.years['tax-savings']) ? response.years['tax-savings'] : (this.currentYear - 1);
      this.yearFilterForFirmGraph = (response.years['published-strategies']) ? response.years['published-strategies'] : (this.currentYear - 1);
      this.yearFilterForTop5Strategies = (response.years['published-strategies']) ? response.years['published-strategies'] : (this.currentYear - 1);
      this.taxPlanningsDefaultYear = (response.years['tax-savings']) ? true : false;
      this.firmStrategiesDefaultYear = (response.years['published-strategies']) ? true : false;
      this.top5StrategiesDefaultYear = (response.years['published-strategies']) ? true : false;
      this.getTotalTaxSavingsPublishedByStrategy();
      this.getFirmsMostPopularPlans();
      this.getTop5StrategiesUsed();
    });
  }

  getTotalTaxSavingsPublishedByStrategy(){
    const base = this;
    this.taxPlanningService.generateTotalPublishedSavingsByStrategy(this.org, this.user, this.defaultGraphType, this.yearFilter)
      .subscribe(metricData => {
        this.hasTotalSavingsByStrategyData = true;
        this.groupedTotalTaxSavingsByStrategyChartOptions = {
          colors: this.chartColors,
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            style: {
              fontFamily: 'Raleway-Regular'
            }
          },
          title: {
            text: '',
            align: 'left',
            style: {
              color: '#444',
              fontFamily: 'Raleway-Regular',
              fontSize: '24'
            }
          },
          subtitle: {
            text: ''
          },
          credits: {
            enabled: false
          },
          legend: {
            enabled: false
          },
          tooltip: {
            pointFormatter(){
              return '<b>Total: ' + base.formatAmount(this.y) + '</b><b>(' + base.getFormattedPercentage(this.percentage) + '%)</b>';
            }
          },
          plotOptions: {
            pie: {
              cursor: 'pointer',
              events: {
                click(event) {
                  if (base.defaultGraphType == 'Strategy') {
                    base.plansFilterStrategyId = event.point.strategyId;
                    base.plansFilterYear = base.yearFilter;
                    base.filterType = 'strategy';
                    base.navigateToClientPlans();
                  } else if (base.defaultGraphType == 'Client') {
                    base.stateService.addState(new State('DASHBOARD', base._router.url, null, null));
                    base._router.navigate(['tax-planning', 'clients', event.point.clientId, 'overview']);
                  }
                }
              }
            }
          },
          pie: {
            dataLabels: {
              enabled: true,
              inside: true,
              formatter(){
                return this.y;
              },
              distance: -40,
              color: 'white'
            },
            showInLegend: true
          },
          series: [{
            colorByPoint: true,
            data: base.getOpexData(metricData.data)
          }]
        };
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  navigateToClientPlans() {
    this.stateService.addState(new State('DASHBOARD', this._router.url, null, null));
    this.showPlansInfo = true;
  }

  getOpexData(data){
    const result = [];
    _.each(data, (valueObj) => {
      result.push({
        name: valueObj.name,
        y: valueObj.savings,
        strategyId: (valueObj.strategyId) ? valueObj.strategyId : '',
        clientId: (valueObj.id) ? valueObj.id : '',
      });
    });
    return result;
  }

  getFormattedPercentage(value){
    return this.numeralService.format('0,0', value);
  }

  formatAmount(amount){
    return this.numeralService.format('$0,0', amount);
  }

  getFirmsMostPopularPlans(){
    const base = this;
    this.taxPlanningService.generateFirmsMostPopularPlansMetricReport(this.org, this.user, this.yearFilterForFirmGraph)
      .subscribe(metricData => {
        this.firmTaxPlansGraphName = 'Your firm’s most popular strategies';
        this.hasFirmsMostPopularPlansData = true;
        const columns = this.getBarCols(metricData.data, false);
        const totalObj = this.getBarColsData(metricData.data, false);
        const series = [];
        _.each(columns, (column) => {
          series.push({
            name: column,
            y: totalObj[column],
            strategyId: totalObj['strategyId']
          });
        });
        this.firmsMostPopularPlans = {
          colors: this.chartColors,
          chart: {
            type: 'column',
            style: {
              fontFamily: 'Raleway-Regular'
            }
          },
          title: {
            text: '',
            align: 'left',
            style: {
              color: '#444',
              fontFamily: 'Raleway-Regular',
              fontSize: '24'
            }
          },
          credits: {
            enabled: false
          },
          xAxis: {
            categories: columns,
            type: 'category',
            labels: {
              style: {
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#444',
                fill: '#444'
              }
            }
          },
          yAxis: {
            title: {
              text: '',
              style: {
                fontSize: '15px'
              }
            },
            labels: {
              style: {
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#444',
                fill: '#444'
              }
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                formatter() {
                  return this.y;
                },
                fontSize: '13px',
                color: '#444',
                fill: '#444',
                style: {
                  fontSize: '13px'
                }
              },
              events: {
                click(event) {
                  base.plansFilterStrategyId = event.point.strategyId;
                  base.plansFilterYear = base.yearFilterForFirmGraph;
                  base.filterType = 'strategy';
                  base.navigateToClientPlans();
                }
              }
            }
          },
          tooltip: {
            formatter: function() {
              return '<b>' + this.x + '</b><br/>' + this.y + '<br/>';
            }
          },
          series: [{
            colorByPoint: true,
            data: series
          }],
        };
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  getTop5StrategiesUsed(){
    const base = this;
    this.taxPlanningService.generateTop5StrategiesMetricReport(this.org, this.user, this.yearFilterForTop5Strategies)
      .subscribe(metricData => {
        /*
                    let metricData = {
                      "data": [
                        {
                          "name": "Retirement Planning",
                          "count": 2,
                          "strategyId": "3c4464bf-41dd-40a3-a117-d1b1b7c76a5e"
                        },
                        {
                          "name": "second",
                          "count": 3,
                          "strategyId": "aa862e75-7154-4b1a-85c4-47bc37a008d4"
                        },
                        {
                          "name": "First Strategy",
                          "count": 2,
                          "strategyId": "e96c9a80-4714-4a29-9b99-79853b65f987"
                        },
                        {
                          "name": "Kathy test",
                          "count": 2,
                          "strategyId": "21027079-16d3-47ff-a350-8ee5d921c051"
                        },
                        {
                          "name": "Keep Order",
                          "count": 3,
                          "strategyId": "b6b3b7b6-3921-4d27-b8db-67bc993ffbc2"
                        }
                      ],
                      "columns": [
                        "name",
                        "count"
                      ]
                    };
        */

        this.hasTop5strategiesData = true;
        const columns = this.getBarCols(metricData.data, false);
        const totalObj = this.getBarColsData(metricData.data, false);
        const series = [];
        _.each(columns, (column) => {
          series.push({
            name: column,
            y: totalObj[column],
            strategyId: totalObj['strategyId']
          });
        });
        this.top5strategies = {
          colors: this.chartColors,
          chart: {
            type: 'column',
            style: {
              fontFamily: 'Raleway-Regular'
            }
          },
          title: {
            text: '',
            align: 'left',
            style: {
              color: '#444',
              fontFamily: 'Raleway-Regular',
              fontSize: '24'
            }
          },
          credits: {
            enabled: false
          },
          xAxis: {
            categories: columns,
            type: 'category',
            labels: {
              style: {
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#444',
                fill: '#444'
              }
            }
          },
          yAxis: {
            title: {
              text: '',
              style: {
                fontSize: '15px'
              }
            },
            labels: {
              style: {
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#444',
                fill: '#444'
              }
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                formatter() {
                  return this.y;
                },
                fontSize: '13px',
                color: '#444',
                fill: '#444',
                style: {
                  fontSize: '13px'
                }
              },
              events: {
                click(event) {
                  base.plansFilterStrategyId = event.point.strategyId;
                  base.plansFilterYear = base.yearFilterForTop5Strategies;
                  base.filterType = 'strategy';
                  base.navigateToClientPlans();
                }
              }
            }
          },
          tooltip: {
            formatter: function() {
              return '<b>' + this.x + '</b><br/>' + this.y + '<br/>';
            }
          },
          series: [{
            colorByPoint: true,
            data: series
          }],
        };

        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });

  }

  getBarCols(data, isForMonth) {
    const result = [];
    _.each(data, (valueObj) => {
      if (isForMonth) {
        result.push(valueObj.month);
      } else {
        result.push(valueObj.name);
      }
    });
    return result;
  }

  getBarColsData(data, isForMonth) {
    const result = {};
    _.each(data, (valueObj) => {
      if (isForMonth) {
        result[valueObj.month] = valueObj.count;
      } else {
        result[valueObj.name] = valueObj.count;
        result['strategyId'] = valueObj.strategyId;
      }
    });
    return result;
  }

  navigateToClients(type?) {
    let link = ['tax-planning', 'clients'];
    if (type && type === 'active') {
      link = ['tax-planning', 'clients'];
    } else if (type && type === 'draft') {
      link = ['tax-planning', 'clients', 'draft'];
    }
    this.stateService.addState(new State('DASHBOARD', this._router.url, null, null));
    this._router.navigate(link);
  }

  onClientsSplitClick(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    if (!target) {
      this.navigateToClients('active');
      return;
    }

    const rect = target.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const isRightSide = clickX > rect.width / 2;

    this.navigateToClients(isRightSide ? 'draft' : 'active');
  }

  navigateToTodos() {
    const link = ['tax-planning/todos'];
    this.stateService.addState(new State('DASHBOARD', this._router.url, null, null));
    this._router.navigate(link);
  }

  navigateToTasks() {
    const link = ['tasks'];
    this.stateService.addState(new State('DASHBOARD', this._router.url, null, null));
    this._router.navigate(link);
  }

  toggleSavings() {
    this.savingsEditable = !this.savingsEditable;
  }

  getSavingsForYear() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxSavingsForYear(this.org, this.user, this.filterYearForSavings)
      .subscribe(response => {
        this.totalTaxSavings = response.total || 0;
        this.savingsEditable = false;
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To get Tax Savings`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  navigateToAnouncements() {
    const link = ['tpiq/announcements'];
    this.stateService.addState(new State('DASHBOARD', this._router.url, null, null));
    this._router.navigate(link);
  }

  getAnnouncementsList() {
    this.loadingService.triggerLoadingEvent(true);
    this.newTpiqService.getAnnouncementsList(this.org, this.user).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.announcementsList = response;
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : `Failed to get announcements data`;
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });
  }

  getActiveAnnouncementsForUser() {
    this.loadingService.triggerLoadingEvent(true);
    this.newTpiqService.getActiveAnnouncementsForUser(this.org, this.user).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.activeAnnouncements = response;
      if (this.activeAnnouncements && this.activeAnnouncements.length > 0) {
        this.currentActiveAnnouncementToShow = this.activeAnnouncements[0];
        this.currentAnnouncementIndex = 0;
        this.reveal.activeAnnouncementsExist = true;
      }
      this.newTpiqService.setShowAnnouncements(false);
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : `Failed to get announcements data`;
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });
  }

  navigateToAnnouncementPage(data) {
    this.announcementId = data.id;
    this.editMode = true;
    this.reveal.addOrEditAnnouncement = true;
  }

  hideReveal(key){
    if (key == 'activeAnnouncementsExist') {
      this.saveAnnouncementAsMarkRead();
    }
    if (key == 'openCreateClientPopup') {
      this.taxPlanningService.clearClientData();
      this.uploadSourceId = '';
      this.client = {};
      this.client = {
        defaultYear: new Date().getFullYear(),
        relatedParties: [],
        status: 'Draft',
        filingStatus: 'Single'
      };
      this.resetUploader();
    }
    if (key == 'openBulkUploadPopup') {
      this.resetUploader();
    }
    this.reveal[key] = false;
  }

  refreshListOfAnnouncements() {
    this.reveal.addOrEditAnnouncement = false;
    this.getAnnouncementsList();
  }

  showNextActiveAnnouncement(index) {
    this.saveAnnouncementAsMarkRead();
    this.currentAnnouncementIndex = index;
    this.currentActiveAnnouncementToShow = this.activeAnnouncements[index];
  }

  saveAnnouncementAsMarkRead() {
    this.newTpiqService.announcementAsMarkRead(this.org, this.user, this.currentActiveAnnouncementToShow.id).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : `Failed to update announcement as mark read`;
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });

  }

  getDashboardGridOrder() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.dashboardGridOrder(this.org, this.user)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.gridOrder = response;
        if (this.gridOrder && this.gridOrder.length === 0) {
          this.gridOrder = ['publishedSavings', 'announcements', 'popularStrategies', 'tasks', 'todos'];
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To get order`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });

  }

  startUpload($event) {
    this.reveal.openCreateClientPopup = true;
    this.reveal.openBulkUploadPopup = false;
  }

  setFileUploader() {
    const base = this;
    const docUrl = this.manageTaxStrategiesServices.getVideoDocumentServiceUrl(this.org, this.user);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }],
      filters: [{
        name: 'fileSizeFilter',
        fn: (item) => {
          const isValid = item.size <= MAX_FILE_SIZE;
          if (!isValid) {
            this.toastService.pop(
              TOAST_TYPE.error,
              `${item.name} exceeds the 275MB size limit`,
              null, 5000
            );
          }
          return isValid;
        }
      },
       {
      name: 'pdfFilter',
      fn: (item: any) => {
        const fileName = item.name?.toLowerCase() || '';
        const mimeType = item.type;

        const isPdfMime = mimeType === 'application/pdf';
        const isPdfExtension = fileName.endsWith('.pdf');

        const isValid = isPdfMime || isPdfExtension;

        if (!isValid) {
          this.toastService.pop(
            TOAST_TYPE.error,
            `${item.name} is not a PDF file. Only PDF files are allowed.`,
            null,
            5000
          );
        }

        return isValid;
      }
    }
    ]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.uploader.onAfterAddingAll = (files: any) => {
      console.log('Total files selected:', files.length);
      if(files.length > 1){
        this.uploadMultipleFiles()
      }else{
        this.startUpload(null);
      }
      
    };
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      if(this.isSingleFileUpload){
        payload.sourceID = (this.client && this.client.id) ? this.client.id : uuid();
      }else{
        this.client['id'] = '';
        payload.sourceID =  uuid();
      }
      
      this.uploadSourceId = payload.sourceID;
      payload.sourceType = 'DASHBOARD_UPLOAD';
      const currentYear = new Date().getFullYear();
      payload.planName = this.client.planName || currentYear+" Plan";
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        //this.uploader.progress = 100;
        if (!this.client.id) {
          if(this.isSingleFileUpload){
            this.saveClient();
          }else{
            this.saveMultiUploadClient();
          }
          
        } else {
          this.updateClient();
        }
      } else {
       setTimeout(() => {
          this.uploader.clearQueue(); // Clear all files from queue
          this.reveal.openBulkUploadPopup = false; 
          },5000)
      }
    };
    this.uploader.onCompleteAll = () => {
      if (this.uploadCanceled) {
        console.log('Upload was canceled. Skipping post-upload steps.');
        return;
      }

      const totalFiles = this.uploader.queue.length;
      let successCount = 0;
      let failureCount = 0;

      this.uploader.queue.forEach(fileItem => {
        if (fileItem.isSuccess) {
          successCount++;
        } else if (fileItem.isError) {
          failureCount++;
        }
      });

      // Redirect only if multiple files upload and all succeeded
      if (totalFiles > 1) {
        if (successCount === totalFiles) {
          setTimeout(() => {
            this.isSingleFileUpload = true;
            this._router.navigate(['tax-planning', 'clients', 'draft']);
          }, 2000)
        } else if (successCount > 0) {
          this.showUploadContinueBtn = true;
        } else {
          if (this.reveal.openCreateClientPopup) {
          this.resetUploader();
          this.toastService.pop(TOAST_TYPE.error, 'Failed to upload documents');
        }
        }
      }
    };
  }

  redirectToDraft() {
    this._router.navigate(['tax-planning', 'clients', 'draft']);
  }

  resetUploader(type?) {
    this.uploader.queue.forEach((item) => {
      item.remove();
    });
  }

  saveMultiUploadClient() {
    if(!this.client.planName){
      const currentYear = new Date().getFullYear();
      this.client.planName = currentYear+" Plan";
    }
    if(!this.client.firstName){
      this.client.firstName = "Extracting...";
    }
    if(!this.client.lastName){
      this.client.lastName = "Extracting...";
    }
    if (this.validateData()){
      this.appendIndyRelatedParty();
      this.client['id'] = this.uploadSourceId;
      this.client['labels'] = [];
      this.client['thirdParties'] = [];
      this.taxPlanningService.createClient(this.org, this.user, this.client).subscribe(response => {
      });
    }
  }

  saveClient() {
    if (this.validateData()){
      this.client['id'] = this.uploadSourceId;
      this.client['labels'] = [];
      this.client['thirdParties'] = [];
      //this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.createClient(this.org, this.user, this.client).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.hideReveal('openCreateClientPopup');
        this.toastService.pop(TOAST_TYPE.success, 'Client created successfully');
        this._router.navigate(['tax-planning', 'clients', 'draft']);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.hideReveal('openCreateClientPopup');
        try{
          const message = error.message ? error.message : 'Failed to create client';
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to create client');
        }
      });
    }
  }

  validateData(){
    if (!this.client.planName){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Plan Name');
      return false;
    }  if (!this.client.firstName){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter First Name');
      return false;
    } else if (!this.client.lastName){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Last Name');
      return false;
    }
    return true;
  }

  openCreateClient() {
    this.reveal.openCreateClientPopup = true;
  }

  uploadFile() {
    const base = this;
    // Get client data from component if available
    if (this.clientSelectCreateComponent) {
      this.client = this.clientSelectCreateComponent.getClientData();
    }
    
    if(this.validateData()) {
      this.loadingService.triggerLoadingEvent(true);
      setTimeout(() => {
        base.uploader.uploadAll();
      }, 1000);
    }
  }

  uploadMultipleFiles() {
    const base = this;
   // this.isUploading = true;
    this.isSingleFileUpload = false;
    this.reveal['openBulkUploadPopup'] = true;
    setTimeout(() => {
    base.uploader.uploadAll();
    }, 1000)
  }

  appendIndyRelatedParty(){
    let indyClient = '';
    if (this.client.firstName){
      indyClient += this.client.firstName;
    }
    if (this.client.lastName){
      indyClient += ` ${this.client.lastName}`;
    }
    const defaultIndy = _.find(this.client.relatedParties, {default: true});
    if (defaultIndy){
      defaultIndy.name = indyClient;
    } else{
      this.client.relatedParties.push({
        name: indyClient,
        type: '1040',
        default: true
      });
    }
  }

  onFilingSelect(status) {
    this.client.filingStatus = status.name;
  }

  // Get Clients(both live and draft) list for 1040 uoload
  getAllClientsList() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getClientsForCoreFocusUpload(this.org, this.user).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.setClientsList(response);
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.error, 'Failed to get clients list');
    });
  }

  setClientsList(clients) {
    const base = this;
    let obj = [];
    _.forEach(clients, function(client) {
      client['name'] = client.firstName + ' ' + client.lastName;
    });
    this.clientsList = clients;
  }

  handleClientSelected(client: any) {
    // Existing client selected - update dashboard's client object
    this.client = client;
  }

  handleClientCreated(response: any) {
    // New client created - client data already handled in component
    this.hideReveal('openCreateClientPopup');
  }

  handleUpload() {
    // Get client data from component and trigger upload
    if (this.clientSelectCreateComponent) {
      this.client = this.clientSelectCreateComponent.getClientData();
    }
    this.uploadFile();
  }

  onClientSelect(client) {
    // Optimistically populate form with available client data
    this.populateClientFormOptimistically(client);

    // Sync with latest data in background
    this.syncClientDataInBackground(client.id);
    // This method is no longer used - kept for backward compatibility if needed
    if (this.clientSelectCreateComponent) {
      this.clientSelectCreateComponent.onClientSelect(client);
    }
  }

  setType($event, relatedPary){
    relatedPary.type = $event.name;
  }

  removeRelatedParty(index){
    this.client.relatedParties.splice(index, 1);
  }

  addRelatedParty(){
    this.client.relatedParties.push({});
    setTimeout(() => {
      this.scrollToBottom();
    }, 100);
  }

  // Optimistic form population - immediate UI update
  populateClientFormOptimistically(client) {
    this.client.id = client.id;
    this.client.firstName = client.firstName;
    this.client.lastName = client.lastName;
    this.client.filingStatus = client.filingStatus || 'Single';
    this.client.defaultYear = client.defaultYear || new Date().getFullYear().toString();
    this.client.relatedParties = client.relatedParties || [];
    this.client.planName = client.planName || `${client.firstName} ${client.lastName} Plan`;

    // Initialize empty arrays if not present
    this.client.labels = this.client.labels || [];
    this.client.thirdParties = this.client.thirdParties || [];
  }

  syncClientDataInBackground(clientId) {
    this.taxPlanningService.getClient(this.org, this.user, clientId, false)
      .subscribe(response => {
        this.updateClientFormWithApiData(response);
      }, error => {
        // Handle API failure gracefully - keep optimistic data but show subtle warning
        this.handleClientSyncError(error);
      });
  }

  // Update form with fresh API data if different from optimistic data
  updateClientFormWithApiData(apiClient) {
    let hasUpdates = false;

    // Update fields that might be different or more current
    if (apiClient.filingStatus !== this.client.filingStatus) {
      this.client.filingStatus = apiClient.filingStatus;
      hasUpdates = true;
    }
    if (apiClient.defaultYear !== this.client.defaultYear) {
      this.client.defaultYear = apiClient.defaultYear;
      hasUpdates = true;
    }
    if (apiClient.relatedParties && JSON.stringify(apiClient.relatedParties) !== JSON.stringify(this.client.relatedParties)) {
      this.client.relatedParties = apiClient.relatedParties;
      hasUpdates = true;
    }
    if (apiClient.labels && JSON.stringify(apiClient.labels) !== JSON.stringify(this.client.labels)) {
      this.client.labels = apiClient.labels;
    }
    if (apiClient.thirdParties && JSON.stringify(apiClient.thirdParties) !== JSON.stringify(this.client.thirdParties)) {
      this.client.thirdParties = apiClient.thirdParties;
    }

    // complete sync
    this.client = { ...this.client, ...apiClient };
  }

  handleClientSyncError(error) {
    // Keep optimistic data but log error for debugging
    console.warn('Failed to sync latest client data, using cached data:', error);

    // Could show a subtle non-blocking warning, but for now just log
    // In future, could add a small warning icon next to form fields
  }

  // Legacy method - kept for backward compatibility but now only used in error cases
  getClient(clientId){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getClient(this.org, this.user, clientId, false)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.client = response;
        this.client.filingStatus = (this.client.filingStatus) ? this.client.filingStatus : 'Single';
        this.client.defaultYear = (this.client.defaultYear) ? this.client.defaultYear : new Date().getFullYear();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to get client data');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get client data');
        }
      });
  }

  updateClient(){
    if (this.validateData()){
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.updateClient(this.org, this.user, this.client.id, this.client).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.hideReveal('openCreateClientPopup');
        this.toastService.pop(TOAST_TYPE.success, 'Client updated successfully');
        this._router.navigate(['tax-planning', 'clients', 'draft']);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to update client');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to update client');
        }
      });
    }
  }

  scrollToBottom(): void {
    this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  }

  fileOverBase(e: any): void {
    this.hasDropZoneOver = e;
  }

  cancelUpload() {
    if (this.uploader && this.uploader.isUploading) {
      this.uploadCanceled = true;
      this.uploader.cancelAll();
    }
  }
  resumeUpload() {
    this.uploadCanceled = false;
    this.uploader.uploadAll();
  }

}
